import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

import { TABLET } from '@app/constants';
import { useUsersAccessRights, useWindowSize } from '@app/hooks';

export const PageHeader = () => {
  const { innerWidth } = useWindowSize();
  const { hasUserRightToCreate } = useUsersAccessRights();

  const label = innerWidth <= TABLET ? '' : 'Добавить пользователя';

  return (
    <>
      {hasUserRightToCreate && (
        <Link to="/users/add">
          <Button type="primary" icon={<PlusOutlined />} data-testid="add-user">
            {label}
          </Button>
        </Link>
      )}
    </>
  );
};
